import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => {
	return {
		container: {
			flex: 'none',
		},
		dialog: {
			zIndex: `calc(${theme.zIndex.floating} - 1)`, // Should be one below the floating level to make drawers pop over it (difference in zIndex between new and old theme)
		},
		dialogTitle: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			fontWeight: theme.weight.bold,
			padding: theme.spacing.small,
		},
		counter: {
			marginRight: 'auto',
		},
		dialogContent: {
			padding: `0 0 ${theme.spacing.big}`,

			[getFromBreakpoint('lg')]: {
				padding: 0,
			},
		},
		dialogActions: {
			position: 'fixed',
			zIndex: theme.zIndex.default,
			left: 0,
			right: 0,
			bottom: 0,
			padding: theme.spacing.small,
			backgroundColor: 'transparent',

			'@global': {
				'& .MuiDialogActions-root': {
					display: 'flex',
					justifyContent: 'center',
					borderTop: '1px solid #e8e8e8',

					'& > .button': {
						flex: '1 1 100%',
						maxWidth: '400px',
					},
				},
			},
		},
		resultsButton: {
			width: '100%',
		},
	};
});
